"use client"

import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import { Linkedin, Send, Twitter, Instagram, Facebook, InstagramIcon } from "lucide-react"
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";

function SocialIcons() {
  return (
    <div style={{ fontSize: "24px", display: "flex", gap: "15px" }}>
      <FaFacebook />
      <FaInstagram />
      <FaTwitter />
      <FaLinkedin />
    </div>
  );
}


const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-gray-400 relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-80"
        style={{
          backgroundImage: "url('/footernew.avif')",
        }}
      />

      {/* Dark Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f1419]/90 via-[#1a1a1a]/85 to-[#0f1419]/90"></div>

      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="container px-4 sm:px-8 pt-10 pb-6 relative z-10"
      >
        {/* Top Section: Four Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          {/* About Tactos */}
          <div className="space-y-4">
          <a href="#startupreadlines">
              <span className="inline-block px-3 py-1 border border-gray-300 bg-transparent rounded-full text-sm text-gray-300">
              About Tactos
            </span>
          </a>
            <p className="text-sm leading-relaxed text-gray-300">
              TACTOS - The Entrepreneurs’ Co-Pilot Platform a one stop solution designed to empower your startup towards success.
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <span className="inline-block px-3 py-1 border border-gray-300 bg-transparent rounded-full text-sm text-gray-300">
              Links
            </span>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-cyan-300 transition-colors text-gray-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="hover:text-cyan-300 transition-colors text-gray-300">
                  TechSupport
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-cyan-300 transition-colors text-gray-300">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/startups" className="hover:text-cyan-300 transition-colors text-gray-300">
                  Invest in Start-Ups
                </Link>
              </li>

              
              {/* <li>
                <Link to="/matrimony" className="hover:text-cyan-300 transition-colors text-gray-300">
                  Matrimony
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="hover:text-cyan-300 transition-colors text-gray-300">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Find Us */}
          <div className="space-y-4">
            <span className="inline-block px-3 py-1 border border-gray-300 bg-transparent rounded-full text-sm text-gray-300">
              Find Us
            </span>
            <div className="flex space-x-4 items-center">
              <a target="_blank" href="https://www.linkedin.com/company/tactos-strategic-solutions-llp" className="hover:text-cyan-300 transition-colors text-gray-300">
                <Linkedin className="w-5 h-5" />
              </a>
              <a target="_blank" href="https://www.instagram.com/tactos_official?igsh=aGprMGhhZXIwdG5y" className="hover:text-cyan-300 transition-colors text-gray-300">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a target="_blank" href="https://www.facebook.com/share/1C9XwZeBaF/" className="hover:text-cyan-300 transition-colors text-gray-300">
                <FaFacebook className="w-5 h-5" />
              </a>
             
            </div>
          </div>
        </div>

        {/* Bottom Section: Copyright & Links */}
        <div className="border-t border-gray-300 pt-6 flex flex-col sm:flex-row items-center justify-between text-gray-400 text-sm">
          {/* Left: Privacy Policy */}
          <div className="mb-4 sm:mb-0 flex flex-wrap gap-x-2 items-center">
            <Link to="/privacy" className="hover:text-cyan-300 transition-colors">
              Privacy Policy
            </Link>
            <span>|</span>
            <Link to="/refund-policy" className="hover:text-cyan-300 transition-colors">
              Refund Policy
            </Link>
            <span>|</span>
            <Link to="/term" className="hover:text-cyan-300 transition-colors">
              Terms and Conditions
            </Link>
          </div>
          <div className="mb-4 sm:mb-0">{new Date().getFullYear()} TACTOS. All rights reserved.</div>
        </div>
      </motion.div>
    </footer>
  )
}

export default Footer
